import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AuthCheck } from '@zg-rentals/auth-check';
import loadable from '@loadable/component';

// Pages
import NotFoundPage from 'app/shared/pages/NotFoundPage';
import UserPage from 'app/shared/pages/UserPage';
import UnsubscribePage from 'app/shared/pages/UnsubscribePage';
import ZRMLoginPage from 'app/shared/pages/ZRMLogin';
// @ts-ignore
import StatsPage from 'app/shared/pages/StatsPage';
import WebSocketPage from 'app/shared/pages/WebSocketPage';

// Components
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// SSR
import FrontPageSrwm from 'app/shared/pages/FrontPage/ssr';
import MarketStatsPageSrwm from 'app/shared/pages/MarketStatsPage/ssr';
import MarketStatsResultsPageSrwm from 'app/shared/pages/MarketStatsResultsPage/ssr';
import PriceMyRentalPageSrwm from 'app/shared/pages/PriceMyRentalPage/ssr';
import PriceMyRentalResultsPageSrwm from 'app/shared/pages/PriceMyRentalResultsPage/ssr';

// Actions / Utils
import pathsManifest from 'app/shared/utils/pathsManifest';
import UserActions from 'app/shared/flux/actions/UserActions';

const FrontPage = loadable(() => import(/* webpackChunkName: "FrontPage.loadable" */ 'app/shared/pages/FrontPage'), {
    fallback: <SpinnerContainer />
});

const PriceMyRentalResultsPage = loadable(
    () =>
        import(/* webpackChunkName: "PriceMyRentalResultsPage.loadable" */ 'app/shared/pages/PriceMyRentalResultsPage'),
    {
        fallback: <SpinnerContainer />
    }
);

const PriceMyRentalPage = loadable(
    () => import(/* webpackChunkName: "PriceMyRentalPage.loadable" */ 'app/shared/pages/PriceMyRentalPage'),
    {
        fallback: <SpinnerContainer />
    }
);

const MarketStatsResultsPage = loadable(
    () => import(/* webpackChunkName: "MarketStatsResultsPage.loadable" */ 'app/shared/pages/MarketStatsResultsPage'),
    {
        fallback: <SpinnerContainer />
    }
);

const MarketStatsPage = loadable(
    () => import(/* webpackChunkName: "MarketStatsPage.loadable" */ 'app/shared/pages/MarketStatsPage'),
    {
        fallback: <SpinnerContainer />
    }
);

// ORDER MATTERS: PUT MORES SPECIFIC ROUTES BEFORE LESS SPECIFIC
// look at PriceMyRental pages
export default function getRoutes() {
    return (
        <Switch>
            <Route
                exact
                component={FrontPage}
                path="/"
                // @ts-ignore
                serverRouteWillMount={FrontPageSrwm}
            />
            <Route
                component={PriceMyRentalResultsPage}
                path={`${pathsManifest.PriceMyRentalPageResults}/:address`}
                // @ts-ignore
                serverRouteWillMount={PriceMyRentalResultsPageSrwm}
            />
            <Route
                component={PriceMyRentalPage}
                path={`${pathsManifest.PriceMyRentalPage}`}
                // @ts-ignore
                serverRouteWillMount={PriceMyRentalPageSrwm}
            />
            <Route
                component={MarketStatsResultsPage}
                path={`${pathsManifest.MarketTrendsPage}/:area`}
                // @ts-ignore
                serverRouteWillMount={MarketStatsResultsPageSrwm}
            />
            <Route
                component={MarketStatsPage}
                path={`${pathsManifest.MarketTrendsPage}`}
                // @ts-ignore
                serverRouteWillMount={MarketStatsPageSrwm}
            />
            {/*
                AuthCheck is a HoC that only renders child component if
                requestAuthFunc returns a user is logged in
            */}
            <Route
                component={AuthCheck({
                    component: FrontPage,
                    requestAuthFunc: UserActions.getUser
                })}
                path="/auth-page"
            />

            {/*
                pageWithSensitiveInformation flag is passed to api to require authentication
                e.g. password typed in recently
            */}
            <Route
                component={UserPage}
                // @ts-ignore
                pageWithSensitiveInformation
                path="/user"
            />
            <Route component={UnsubscribePage} path={`${pathsManifest.UnsubscribePage}/:campaign`} />

            <Route component={WebSocketPage} path={pathsManifest.WebSocketPage} />
            <Route component={StatsPage} path={pathsManifest.StatsPage} />
            <Route component={ZRMLoginPage} path={pathsManifest.ZRMLoginPage} />

            <Route component={NotFoundPage} path="*" />
        </Switch>
    );
}
